<template>
  <v-dialog
    transition="dialog-top-transition"
    max-width="600"
    v-model="showWarning"
    persistent
  >
    <template v-slot:default>
      <v-card>
        <v-card-text class="pa-8">
          <h2>
            You're session is about to end in
            <span class="primary--text">{{ logoutSecondsTimer }} seconds</span>
          </h2>
          <div class="mt-4">
            You have been inactive for a while. For security purposes, we'll log
            you out in {{ logoutSecondsTimer }} seconds. Choose
            <span class="highlight primary--text">Log Out Now</span> to continue
            or <span class="highlight primary--text">Stay Logged In</span> if
            you're done.
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn class="mr-4" text @click="logout" outlined>Log Out Now</v-btn>
          <v-btn @click="extendSession" class="black--text" color="primary"
            >Stay Logged In</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import auth from "@/app/auth";

export default {
  name: "AutoLogout",
  data() {
    return {
      showWarning: false,
      activityEvents: ["click", "mousedown", "scroll", "keypress", "load"],
      warningTimer: null,
      logoutTimer: null,
      logoutTimerEnabled: null,
      secondsBeforeLogout: 60,
      logoutSecondsTimer: null,
    };
  },
  mounted() {
    this.$log.debug(
      `adding listeners for the following: ${this.activityEvents.join(",")}`
    );
    this.activityEvents.forEach((event) => {
      window.addEventListener(event, this.onUserInteraction);
    }, this);

    this.setTimers();
    this.setRefreshTimer();
  },
  destroyed() {
    this.activityEvents.forEach((event) => {
      window.removeEventListener(event, this.onUserInteraction);
    }, this);
  },
  watch: {
    logoutTimerEnabled(value) {
      if (value) {
        setTimeout(() => {
          this.logoutSecondsTimer--;
        }, 1000);
      }
    },

    logoutSecondsTimer: {
      handler(value) {
        if (value > 0 && this.logoutTimerEnabled) {
          setTimeout(() => {
            this.logoutSecondsTimer--;
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  methods: {
    setTimers() {
      const warningTimerDuration = 60 * 1000 * 60; // 60 minutes = 60 * 1000 * 60
      this.logoutSecondsTimer = this.secondsBeforeLogout; // reset the logoutSecondsTimer
      this.warningTimer = setTimeout(this.warningMessage, warningTimerDuration);
      this.logoutTimer = setTimeout(
        this.logout,
        warningTimerDuration + this.logoutSecondsTimer * 1000
      );
    },
    setRefreshTimer() {
      const refreshTimerDuration = 5 * 1000 * 60; // 5 minutes = 10 * 1000 * 60
      this.refreshTimer = setTimeout(this.refreshSession, refreshTimerDuration);
    },
    warningMessage() {
      this.showWarning = true;
      this.logoutTimerEnabled = true;
    },
    extendSession() {
      this.$log.debug("extending session and hiding warning...");
      this.showWarning = false;
      this.resetTimer();
    },
    refreshSession() {
      this.$log.debug("refreshing session...");
      auth.auth.refreshSession(
        auth.auth.getSignInUserSession().getRefreshToken().getToken()
      );
      auth.handleAuthSuccess();
      this.showWarning = false;
      this.resetRefreshTimer();
    },
    logout() {
      this.$log.debug("logging out...");
      auth.logout();
    },
    onUserInteraction() {
      this.$log.debug(
        `detected user interaction, showWarning=${this.showWarning}`
      );
      // only reset if the warning hasn't already appeared
      if (!this.showWarning) {
        this.resetTimer();
      }
    },
    resetTimer: function () {
      this.$log.debug();
      clearTimeout(this.warningTimer);
      clearTimeout(this.logoutTimer);
      this.logoutTimerEnabled = false;
      this.setTimers();
    },
    resetRefreshTimer: function () {
      clearTimeout(this.refreshTimer);
      this.setRefreshTimer();
    },
  },
};
</script>

<style lang="scss" scoped>
.highlight {
  font-weight: bold;
}
</style>
